import BaseEvent from './base_event';
import {RoboInvasion} from './invasion';
import * as effects from '../effects'
import * as ItemsFactory from '../../objects/items/items_factory';
import { Rarity } from '../../objects/items/base_item'

export default class AlienEncounterEvent extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.alien_encounter;
    }

    enter(gameState) {
        gameState.eventsResults.alien_encounter = true;

        let room = gameState.getRandomRoomWithoutHero();
        this.ui.showDialog({
            message:
            `You enjoy your untasty dinner, when all ship systems suddenly crash, and your room is flooded with light. Two mechanical figures appear from the thin air, and slowly approach you, speaking weird language.\n"LAPTAT RAIT RALUTOLA?"`,
            options: [{
                text: `Your* alien friend* suddenly jumps in front of you and speaks the same language. "KLAATU BARADA NIKTO"`,
                condition: gameState.has('friendly_alien'),
                secret: true,
                callback: () => {
                    let item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                    gameState.items.add(item);
                    gameState.history.push({ id: 'aenc', msg: 'made friends with Klaatu'});
                    this.ui.showDialog({
                        message: `Robots slowly nod in appreciation and disappear, leaving something lying on the floor. You look at your alien friend, but no explanation is given whatsoever. Let’s go back to dinner.`,
                        status: "+" + item.constructor.label
                    }, this.end);
                }
            }, {
                text: `"NO, YOU ARE STUPID"`,
                callback: () => {
                    let dice_roll = game.rnd.frac();
                    gameState.history.push({ id: 'aenc', msg: 'used a "NO U" diplomatic argument'});
                    if (dice_roll < 0.5) {
                        let item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                        gameState.items.add(item);

                        this.ui.showDialog({
                            message: `Robots make weird cackling noises and disappear in a flash of light, leaving something behind. You congratulate yourself on a successful diplomacy attempt and get back to dinner.`,
                            status: "+" + item.constructor.label
                        }, this.end);
                    } else {
                        this.ui.showDialog({
                            message: `Robots shriek and disappear without a trace, leaving you a nice present of droids concerned with your extermination. Looks like you’ve made them angry. Nice try, dumbass.`,
                            status: "Droid attack!"
                        }, () => {
                            this.schedule(RoboInvasion, 0);
                            this.end();
                        });
                    }
                }
            }, {
                text: `"Sorry, I don’t know what that means"`,
                callback: () => {
                    gameState.history.push({ id: 'aenc', msg: 'was a reasonable person. Occasionally'});
                    let item = ItemsFactory.produceByRarity(room, Rarity.COMMON)[0];
                    gameState.items.add(item);
                    this.ui.showDialog({
                        message: `  
                    Robots nod, as if disappointed, and slowly fade away. You feel like it was a rare smart decision from you, and promise yourself to make 10 stupid things before sleep to restore balance.`,
                        status: "+" + item.constructor.label
                    }, this.end);
                }
            }]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/alien_encounter.js